export const changeincome_other_gradesReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_INCOME_OTHER_GRADES":
        return action.payload.income_other_grades;
      default:
        return state;
    }
  };
  